import { render } from "./App.vue?vue&type=template&id=67ae91aa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=67ae91aa&lang=css"

import exportComponent from "../node_modules/_vue-loader@17.2.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__